// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".other-list[data-v-60a92358] {\n  width: 100%;\n  margin-bottom: 25px;\n}\n.other-list .chart-other[data-v-60a92358] {\n  width: 100%;\n  height: 280px;\n}", ""]);
// Exports
module.exports = exports;
